import { Col, Divider, Modal, Row, Button, Spin, Drawer, Skeleton } from "antd";
import React, { useContext, useEffect } from "react";
import SalesService, { PaymentMethodNames } from "../../Services/SalesService";
import { useClient } from "../../Context/ClientContext";
import noteContext from "../../Context/StyleContext";
import "../../Common/AddPageCommon.css";
import { LoadingOutlined } from "@ant-design/icons";
import { notificationContext } from "../../Common/PageRoute";
import { dayjs } from "../../../Utilities/dayjs";
import { useLocation } from "react-router-dom";
import VoucherServices, {
  Party_Tax,
  Voucher_Type,
} from "../../Services/VoucherServices";
import { Utils } from "../../../Utilities/Utils";
import { useNavigate } from "react-router";
import { useUser } from "../../../Context/UserContext";
import {
  Page,
  Text,
  View,
  Document,
  PDFViewer,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import { Table, TR, TH, TD } from "@ag-media/react-pdf-table";
import { IAddressDetails } from "../../Services/SettingService";
import { TypeOfAddress } from "../../Services/LedgerService";

Font.register({
  family: "Arial",
  fonts: [
    {
      src: "/fonts/arial.ttf",
    },
    {
      fontStyle: "bold",
      src: "/fonts/arialbd.ttf",
    },
  ],
});

//style
const styles = StyleSheet.create({
  body: {
    fontFamily: "Arial",
    fontSize: "14px",
  },
  headerStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    lineHeight: "17px",
  },
  SubHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    lineHeight: "20px",
    paddingTop: "10px",
  },
  fontPadding: { padding: "5px 0px", lineHeight: "20px" },
  FooterfontPadding: {
    fontSize: "14px",
    padding: "5px 0px",
    lineHeight: "20px",
    width: "50%",
  },
  FooterStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: "14px",
    paddingTop: "50px",
  },
  summaryTableStyleRight: {
    padding: "2px",
    justifyContent: "flex-end",
    // textAlign: "right",
  },
  summaryTableStyleLeft: {
    padding: "2px",
    justifyContent: "flex-start",
    // textAlign: "left",
  },
  summaryTableStyleCenter: {
    padding: "2px",
    justifyContent: "center",
    // textAlign: "center",
  },
  pad_2: { padding: "2px" },
  pageNumbers: {
    bottom: 20,
    position: "absolute",
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: "10px",
  },
  stripedRow: { backgroundColor: "#ececec" },
});

const JournalVoucherPDF: React.FC<{
  open: boolean;
  onCancel: any;
  voucherId: string | undefined;
}> = (props) => {
  console.log(props);
  const { currentClient, companySettings } = useClient();
  const { getAllIndStates } = useUser();
  const stateOptions: any = getAllIndStates();
  const { openNotification } = useContext(notificationContext);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [data, setData] = React.useState<any>({});

  const templeteAddressSelected: IAddressDetails =
    currentClient?.addresses?.find(
      (x) =>
        x.addressName ===
        companySettings?.setting?.templateSettings?.[0]?.companyTS
          ?.defaultAddress
    ) ?? currentClient?.addresses
      ? currentClient?.addresses[0]
      : {
          type: TypeOfAddress.RegisteredAddress,
          addressName: "",
          address: {
            city: "",
            state: -1,
            pincode: "",
            country: "",
            building: "",
            street: "",
            landmark: "",
            district: "",
          },
        };

  useEffect(() => {
    if (props.voucherId) {
      setLoading(true);
      VoucherServices.getVoucharById(
        currentClient?.id!,
        props.voucherId,
        Voucher_Type.Journal
      )
        .then((res: any) => {
          setLoading(false);
          setData({
            date: dayjs(res.result?.date).format("DD-MM-YYYY"),
            number: res.result?.number,
            narration: res.result?.narration,
            effectiveLedger: res.result?.effectiveLedger,
            partyLedger: res.result?.partyLedger,
            voucherTitle: res.result?.voucherTitle,
            voucherNetAmount: res.result?.amountSummary?.totalInvoiceAmount,
            amountInWords: res.result?.amountSummary?.totalInvoiceAmountInWords,
          });
        })
        .catch((ex: any) => {
          openNotification("error", ex.message);
          setLoading(true);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, props.voucherId]);

  return (
    <React.Fragment>
      <Drawer
        open={props.open}
        width={"50%"}
        style={{ maxHeight: `calc(100%)`, overflowY: "auto" }}
        onClose={() => props.onCancel()}
        title="Preview"
        loading={loading}
      >
        <PDFViewer width="100%" height="100%">
          <Document title="Document">
            <Page size="A4" style={{ padding: "20px" }} wrap>
              <View style={styles.body}>
                {/* Header */}
                <View>
                  <View style={styles.headerStyle}>
                    <div>
                      <Text
                        style={{
                          fontSize: "18px",
                          fontStyle: "bold",
                          lineHeight: "20px",
                        }}
                      >
                        {currentClient?.businessName}
                      </Text>
                      {templeteAddressSelected?.address?.building !== null ? (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Text>
                            {templeteAddressSelected?.address?.building!}
                          </Text>
                          {templeteAddressSelected?.address?.street !== null ? (
                            <>
                              <Text>
                                {", "}
                                {templeteAddressSelected?.address?.street}
                              </Text>
                              <br />
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                      {templeteAddressSelected?.address?.landmark !== null ? (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Text>
                            {templeteAddressSelected?.address?.landmark}
                            {", "}
                          </Text>
                        </div>
                      ) : (
                        ""
                      )}
                      {templeteAddressSelected?.address?.city !== null ? (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Text>
                            {templeteAddressSelected?.address?.city}
                            {", "}
                          </Text>
                          {templeteAddressSelected?.address?.district !==
                          null ? (
                            <>
                              <Text>
                                {templeteAddressSelected?.address?.district}
                              </Text>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                      {templeteAddressSelected?.address?.state !== null ? (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Text>
                            <Text style={{ fontStyle: "bold" }}>State: </Text>
                            <Text>
                              {currentClient?.state
                                ? Object.entries(stateOptions)?.map(
                                    ([key, s]: any) =>
                                      s.id === currentClient?.state
                                        ? s.name + ", "
                                        : ""
                                  )
                                : Object.entries(stateOptions)?.map(
                                    ([key, s]: any) =>
                                      s.id ===
                                      templeteAddressSelected?.address?.state
                                        ? s.name + ", "
                                        : ""
                                  )}{" "}
                            </Text>
                            <Text style={{ fontStyle: "bold" }}>Code: </Text>
                            <Text>
                              {currentClient?.state
                                ? currentClient?.state
                                    .toString()
                                    .padStart(2, "0")
                                : templeteAddressSelected?.address?.state
                                    .toString()
                                    .padStart(2, "0")}
                            </Text>
                          </Text>
                          <br />
                        </div>
                      ) : (
                        ""
                      )}
                      {currentClient?.gstin !== null ? (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Text>
                            <Text style={{ fontStyle: "bold" }}>GSTIN: </Text>
                            <Text>{currentClient?.gstin}</Text>
                          </Text>
                          <br />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      <Text style={{ fontStyle: "bold", fontSize: "16px" }}>
                        {data?.voucherTitle?.name}
                      </Text>
                    </div>
                  </View>

                  <View style={styles.headerStyle}>
                    <div style={styles.SubHeader}></div>

                    <div style={styles.SubHeader}>
                      <div style={styles.fontPadding}>
                        <div style={{ alignItems: "flex-end" }}>
                          <Text>
                            <Text style={{ fontStyle: "bold" }}>Date: </Text>
                            <Text>{data?.date}</Text>
                          </Text>
                        </div>
                        <div>
                          <Text>
                            <Text style={{ fontStyle: "bold" }}>
                              Voucher No.:{" "}
                            </Text>
                            <Text>{data?.number}</Text>
                          </Text>
                        </div>
                      </div>
                    </div>
                  </View>
                </View>

                {/* Content */}
                <View wrap={false}>
                  <Table
                    style={styles.fontPadding}
                    tdStyle={{ padding: "5px", width: "100%" }}
                  >
                    <TH style={{ backgroundColor: "#ececec" }}>
                      <TD weighting={0.6}>
                        <Text style={{ fontStyle: "bold" }}>Ledger(s)</Text>
                      </TD>
                      <TD
                        weighting={0.2}
                        style={{
                          justifyContent: "flex-end",
                          fontStyle: "bold",
                        }}
                      >
                        Debit (In ₹)
                      </TD>
                      <TD
                        weighting={0.2}
                        style={{
                          justifyContent: "flex-end",
                          fontStyle: "bold",
                        }}
                      >
                        Credit (In ₹)
                      </TD>
                    </TH>
                    {/* Extracting Effective Ledgers */}
                    {data?.effectiveLedger?.map((itm: any, i: any) => {
                      return (
                        <>
                          <TR
                            key={i}
                            // style={i % 2 !== 0 ? styles.stripedRow : {}}
                          >
                            <TD
                              weighting={0.6}
                              style={{
                                flexDirection: "column",
                                alignItems: "flex-start",
                              }}
                            >
                              {itm?.ref?.filter((r: any) => r.id !== null)
                                .length > 0 ? (
                                <Text style={{ textDecoration: "underline" }}>
                                  {itm?.ledgerName}
                                </Text>
                              ) : (
                                <Text>{itm?.ledgerName}</Text>
                              )}
                              {itm?.partyOrTax === Party_Tax.party ? (
                                <Table style={{ fontSize: "12.5px" }}>
                                  {itm?.ref?.map((el: any, index: any) => {
                                    return (
                                      <TR
                                        key={index}
                                        style={{
                                          lineHeight: "14px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        <TD
                                          style={{
                                            paddingTop: "5px",
                                            border: 0,
                                          }}
                                        >
                                          {"     "}
                                          {index + 1}.{"    "}
                                          Ref Name - {el?.name} {"    "} Amount
                                          -{" "}
                                          {Utils.getFormattedNumber(el?.value)}
                                        </TD>
                                      </TR>
                                    );
                                  })}
                                </Table>
                              ) : (
                                ""
                              )}
                            </TD>
                            <TD
                              weighting={0.2}
                              style={{
                                justifyContent: "flex-end",
                              }}
                            >
                              {/* ₹  */}
                              {Utils.getFormattedNumber(Math.abs(itm?.amount))}
                            </TD>
                            <TD
                              weighting={0.2}
                              style={{
                                justifyContent: "flex-end",
                              }}
                            >
                              -
                            </TD>
                          </TR>
                        </>
                      );
                    })}
                    {/* Extracting Party Ledgers */}
                    {data?.partyLedger?.map((itm: any, i: any) => {
                      return (
                        <>
                          <TR
                            key={i}
                            // style={i % 2 !== 0 ? styles.stripedRow : {}}
                          >
                            <TD
                              weighting={0.6}
                              style={{
                                flexDirection: "column",
                                alignItems: "flex-start",
                              }}
                            >
                              {itm?.ref?.filter((r: any) => r.id !== null)
                                .length > 0 ? (
                                <Text style={{ textDecoration: "underline" }}>
                                  {itm?.ledgerName}
                                </Text>
                              ) : (
                                <Text>{itm?.ledgerName}</Text>
                              )}
                              {itm?.partyOrTax === Party_Tax.party ? (
                                <Table style={{ fontSize: "12.5px" }}>
                                  {itm?.ref?.map((el: any, index: any) => {
                                    return (
                                      <TR
                                        key={index}
                                        style={{
                                          lineHeight: "14px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        <TD
                                          style={{
                                            paddingTop: "5px",
                                            border: 0,
                                          }}
                                        >
                                          {"     "}
                                          {index + 1}.{"    "}
                                          Ref Name - {el?.name} {"    "} Amount
                                          -{" "}
                                          {Utils.getFormattedNumber(el?.value)}
                                        </TD>
                                      </TR>
                                    );
                                  })}
                                </Table>
                              ) : (
                                ""
                              )}
                            </TD>

                            <TD
                              weighting={0.2}
                              style={{
                                justifyContent: "flex-end",
                              }}
                            >
                              -
                            </TD>
                            <TD
                              weighting={0.2}
                              style={{
                                justifyContent: "flex-end",
                              }}
                            >
                              {/* ₹  */}
                              {Utils.getFormattedNumber(Math.abs(itm?.amount))}
                            </TD>
                          </TR>
                        </>
                      );
                    })}
                  </Table>
                </View>

                {/* Footer */}
                <View>
                  <div style={styles.headerStyle}>
                    <div style={styles.FooterfontPadding}>
                      <Text style={{ textDecoration: "underline" }}>
                        Amount (in words):
                      </Text>
                      <Text style={{ fontSize: "12px", lineHeight: "14px" }}>
                        INR {data?.amountInWords}
                      </Text>
                      <Text style={{ fontStyle: "bold", marginTop: "5px" }}>
                        Description:
                      </Text>
                      <Text style={{ fontSize: "12px", lineHeight: "14px" }}>
                        {data?.narration}
                      </Text>
                    </div>
                    <div style={{ width: "40%" }}>
                      <div
                        style={{
                          fontSize: "15px",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          borderBottom: "1px solid gray",
                          padding: "5px",
                          fontStyle: "bold",
                        }}
                      >
                        <Text>Total : </Text>
                        <Text>
                          ₹ {Utils.getFormattedNumber(data?.voucherNetAmount)}
                        </Text>
                      </div>
                    </div>
                  </div>
                  <div style={styles.FooterStyle}>
                    <Text style={{ fontStyle: "bold" }}>Prepared by</Text>
                    <Text style={{ fontStyle: "bold" }}>Checked by</Text>
                    <Text style={{ fontStyle: "bold" }}>
                      Authorized Signatory
                    </Text>
                  </div>
                </View>
              </View>
            </Page>
          </Document>
        </PDFViewer>
      </Drawer>
    </React.Fragment>
  );
};
export default JournalVoucherPDF;
